import { render, staticRenderFns } from "./NewDataDetails.vue?vue&type=template&id=65fd0b8e&scoped=true"
import script from "./NewDataDetails.vue?vue&type=script&lang=js"
export * from "./NewDataDetails.vue?vue&type=script&lang=js"
import style0 from "./NewDataDetails.vue?vue&type=style&index=0&id=65fd0b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd0b8e",
  null
  
)

export default component.exports